import React from 'react';

import { Block } from '../common/Block.jsx';
import { Builder, EditorContainer, EmptyPlaceholder } from '../layout/Builder.jsx';
import Defaults from '../layout/Defaults.jsx';
import HeaderText from './HeaderText.jsx';
import Kit from '../layout/Kit.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';
import Utilities from '../common/Utilities.jsx';

function ContentContainer(props) {
    const contentConfig = props.contentConfig || {};
    let blocks = [];
    if (contentConfig.desktop && contentConfig.desktop.blocks) {
        blocks = contentConfig.desktop && contentConfig.desktop.blocks;
    }
    let containerStyle = {};
    Utilities.copyObject(props.style, containerStyle);
    let handleBuilderBlockProps;
    if (props.builder) {
        handleBuilderBlockProps = (d, blockConfig, parentProps) => {
            const blockProps = Builder.handleBlockProps(d, blockConfig, parentProps) || {};
            if (!d.type) {
                return blockProps;
            }
            switch (d.type.value) {
                case Name.Block.ImageV1:
                    if (d.config && d.config.layout && d.config.layout.maxHeight && d.config.layout.maxHeight.value && d.config.layout.maxHeight.value.length > 0) {
                        break;
                    }
                    if (!blockProps.style) {
                        blockProps.style = {};
                    }
                    blockProps.style.width = '100%';
                    break;
                case Name.Block.Map:
                case Name.Block.Video:
                    if (parentProps.inLayout) {
                        if (!blockProps.style) {
                            blockProps.style = {};
                        }
                        blockProps.style.width = '100%';
                    }
                    break;
            }
            return blockProps;
        }
        if (!props.editor) {
            containerStyle.pointerEvents = 'none';
        }
    }
    let alignment;
    const handleMapStyleConfigComplete = (style) => Block.updateAlignment(style, alignment)
    const handleMapStyleConfigProp = (_, propName, propValue) => {
        switch (propName) {
            case 'textAlign':
                alignment = propValue;
                return true;
        }
    }
    return (
        <EditorContainer
            {...props}
            blocks={blocks}
            builderBlockPropsHandler={handleBuilderBlockProps}
            className={`cell--whitelabel cell--whitelabel--${props.pageType}`}
            containerProps={contentConfig.desktop && contentConfig.desktop.page}
            style={containerStyle}
            onContainerProps={props.onPageProps}
            onMapStyleConfigComplete={handleMapStyleConfigComplete}
            onMapStyleConfigProp={handleMapStyleConfigProp} />
    );
}

// region CONTENT META

function _ContentMetaComponent(props) {
    let style = {};
    if (props.blockConfig && props.blockConfig.container) {
        Block.mapStyleConfigProps(style, props.blockConfig.container);
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props);
    return (
        <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>
            {
                props.content != undefined &&
                <div className="cont--kit__content" style={layoutStyles.style}>
                    <div className="cont cont--token cont--blog-post" dangerouslySetInnerHTML={{ __html: props.content }}></div>
                </div>
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
}
const ContentMetaComponent = Token.withContentTokenParsing(
    _ContentMetaComponent,
    { extraParseConditionHandler: (props) => [props.data.publishedAt, props.data.title], headerConversionMap: { [Token.Title]: 'h1' } },
    (props, keyword, options) => Token.parsing.blogContent({ blogContent: props.data }, keyword, options)
);
const ContentMetaTokens = () => {
    return [
        { display: 'Title', token: Token.Title },
        { display: 'Published Date', token: Token.Published }
    ];
}
const Meta = { Component: ContentMetaComponent, Tokens: ContentMetaTokens };

// region CONTENT TITLE (-- DEPRECATED use `Meta` --)

function ContentTitleComponent(props) {
    return (
        <HeaderText.TokenizedComponent
            {...props}
            defaultDesign={Defaults.Block[Name.Block.Blog.TitleV1].Display}
            title={props.data && props.data.Title}
            type={Kit.Type.BlogPost}
            onParseConditions={(props) => [props.title]} />
    )
}
const Title = { Component: ContentTitleComponent, Tokens: ContentMetaTokens };

export { 
    ContentContainer, 
    Meta, 

    // DEPRECATED
    Title
}